import { AbstractControl, ValidationErrors, Validators } from "@angular/forms";
import { errorCode } from "../../app/redesign/components/form-field/form-errors.const";
import isMobilePhone from "validator/lib/isMobilePhone";
import { otherDeliveryTime } from "../../app/redesign/components/form-field/order-time-form-field/order-time.enum";

export function passwordConfirmationValidator(control: AbstractControl, password: string): ValidationErrors | null {
  if (control.value != password) {
    return { [errorCode.passwordNotEqual]: true };
  }

  return null;
}

export function orderFulfillmentTimeValidator(control: AbstractControl, orderTime: string): ValidationErrors | null {
  if (orderTime === otherDeliveryTime && !control.value) {
    return { [errorCode.required]: true };
  }

  return null;
}

export function booleanValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value === undefined || control.value === null) {
    return null;
  }

  if (control.value !== true && control.value !== false) {
    return { [errorCode.notBoolean]: true };
  }

  return null;
}

export function numberValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value === undefined || control.value === null) {
    return null;
  }
  const number = Number(control.value);

  return isNaN(number) ? { [errorCode.notNumber]: true } : null;
}

export function phoneValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  if (!isMobilePhone(control.value)) {
    return { [errorCode.notPhoneNumber]: true };
  }

  return null;
}

export function minDateValidator(control: AbstractControl, minDate: Date): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  if (new Date(control.value) < minDate) {
    return { [errorCode.minDate]: true };
  }

  return null;
}

export const isNumberValidator = Validators.pattern(/^[0-9]+$/);
